<template>
  <div class="telemetry-brk-press-fr-parts">
    <svg
      class="telemetry-brk-press-fr-parts__gauge"
      width="303"
      height="200"
      viewBox="0 0 303 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <clipPath id="telemetry-brk-press-fr-parts__gauge__clip">
        <rect width="303" :height="gaugeHeight" x="0" :y="gaugePositionY" fill="white"></rect>
      </clipPath>

      <path
        clip-path="url(#telemetry-brk-press-fr-parts__gauge__clip)"
        opacity="0.8"
        d="M0 24C0 10.7452 10.7452 0 24 0H120V4H66C59.3726 4 54 9.37258 54 16V136.059C54 142.424 51.4714 148.529 46.9706 153.029L0 200V24Z"
        fill="white"
      />
      <path
        clip-path="url(#telemetry-brk-press-fr-parts__gauge__clip)"
        d="M0 24C0 10.7452 10.7452 0 24 0H120V1H25C12.2974 1 2 11.2975 2 24V198L0 200V24Z"
        fill="white"
      />

      <g opacity="0.3">
        <path
          d="M0 24C0 10.7452 10.7452 0 24 0H120V4H66C59.3726 4 54 9.37258 54 16V136.059C54 142.424 51.4714 148.529 46.9706 153.029L0 200V24Z"
          fill="url(#paint0_linear_757_14831)"
        />
        <path
          d="M0 24C0 10.7452 10.7452 0 24 0H120V1H25C12.2974 1 2 11.2975 2 24V198L0 200V24Z"
          fill="white"
        />
      </g>
      <path
        opacity="0.6"
        d="M0 88L12.4853 100.485C14.7357 102.736 16 105.788 16 108.971V184L0 200V88Z"
        fill="black"
      />
      <defs>
        <linearGradient
          id="paint0_linear_757_14831"
          x1="51"
          y1="250"
          x2="-1.22056e-08"
          y2="250"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0.3" />
          <stop offset="1" stop-color="white" stop-opacity="0.8" />
        </linearGradient>
      </defs>
      <text class="telemetry-brk-press-fr-parts__label" x="-179" y="12" transform="rotate(-90)">
        BRAKE
      </text>
    </svg>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'
import useTelemetrySectionUtil from '@/components/RaceVideoPage/RaceVideoDataViewPane/hook/useTelemetrySectionUtil'

/**
 * レース動画再生画面 テレメトリー ブレーキ圧 パーツのコンポーネント
 */
export default defineComponent({
  name: 'TelemetryBrkPressFrParts',
  components: {},
  props: {
    /**
     * バリュー値
     */
    value: {
      type: Number,
      required: true,
      default: 0,
    },
    /**
     * ゲージMAX値
     */
    max: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  setup(props) {
    const { adjustPosition } = useTelemetrySectionUtil()

    // 位置指定を整数化
    adjustPosition('.telemetry-brk-press-fr-parts')

    // ゲージ高さ
    const gaugeSvgHeight = 200

    /**
     * gaugeHeight
     * ゲージの高さを算出
     */
    const gaugeHeight = computed(() => (gaugeSvgHeight * props.value) / props.max)

    /**
     * gaugePositionY
     * ゲージのY位置を算出
     */
    const gaugePositionY = computed(
      () => gaugeSvgHeight - (gaugeSvgHeight * props.value) / props.max,
    )

    return {
      gaugeHeight,
      gaugePositionY,
    }
  },
})
</script>

<style lang="scss" scoped>
.telemetry-brk-press-fr-parts {
  position: absolute;
  left: calc(#{min(4.2667vw, 1.333em)} + 1.6667em);
  top: calc(#{min(4.2667vw, 1.333em)} + 2em);
  width: 25.25em;
  height: 16.6667em;

  &__gauge {
    position: absolute;
    width: 100%;
    z-index: 1;

    rect {
      transition: all linear $telemetryFps;
    }
  }

  &__label {
    fill: $white;
    letter-spacing: 0.04em;
    font-weight: 500;
    font-size: 12px;
  }
}
</style>

<style lang="scss">
.race-telemetry-section {
  &--landscape-primary,
  &--landscape-secondary {
    .telemetry-brk-press-fr-parts {
      top: 2.4em;
    }
  }
}
</style>
